export const styles = {
	outerContainer: {
		display: 'flex',
		flexDirection: 'column',
		rowGap: '3rem',
		flexGrow: 1,
	},
	innerContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
	},
	instructionContainer: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		flexWrap: 'wrap',
		'@media (max-width: 600px)': {
			flexWrap: 'noWrap',
		},
	},
	instructionText: {
		opacity: '87%',
		width: '86%',
		color: 'black',
	},
	businessComparisonButton: (isSelected: boolean) => ({
		color: 'black',
		fontWeight: 'normal',
		textTransform: 'capitalize',
		backgroundColor: isSelected ? '#E4F4D8' : 'none',
		'&:hover': {
			backgroundColor: isSelected ? '#E4F4D8' : 'none',
		},
		borderRadius: '4px',
		border: '1px solid var(--light-other-outlined-border-23-p, #0000003B)',
		width: 'auto',
	}),
}
